import VForm from '@/vuetify_custom/v-form'
import VModal from '@/vuetify_custom/v-modal_v1'
import { createSalaryAdjustV2, createSalaryAdjustV2Display } from '@/views/fin/salaryadministration/utils.js'
import employmentTypesMixin from '@/views/fin/salaryadministration/common_mixins.js'
import { mapGetters } from 'vuex'
import { getsafe } from '@/libs/util.js'
import {adjustApi} from '../service'
import styles from '../index.module.less'
import s_styles from './pay.module.less'
import {getSubsidizedMealsSetDetailApi} from '@/views/fin/salaryadministration/service.js'
const invalidValue = [ undefined, null, '']
const bt = (val) => !invalidValue.includes(val) || '必填'
const bx = (val) => !invalidValue.includes(val) || '必选'


export default {
    mixins:[employmentTypesMixin],
    props: {
        workingDayTip: {
            type: String
        }
    },
    data() {
        this.sourceData = null
        return {
            show:false,
            saveLoading: false,
            params: createSalaryAdjustV2(),
            forms_height:null,
            cb_cy_hash:null,
            teamList: []
        }
    },
    computed:{
        ...mapGetters('async', ['companies', 'companies_hash']),
        modify_list_hash() {
            return this.params.modify_list.reduce((total, item) => {
                total[item.type] = item
                return total
            }, {})
        },
        base_fields() {
            return [
                {
                    label: '姓名',
                    type: 'text_dis',
                    key: 'customer_name',
                    cols: 2,
                },
                {
                    label: '身份证',
                    type: 'text_dis',
                    key: 'id_number',
                    cols: 3,
              
                },
                {
                    label: '银行卡号',
                    type: 'text_dis',
                    key: 'bank_number',
                    cols: 3,
              
                },
                {
                    label: '劳动关系所在公司',
                    type: 'autocompletes',
                    key: 'company_id',
                    cols: 4,
                    clearable:true,
                    items: this.companies,
                    'item-value':'id',
                    'item-text':'name',
                    change: (v) => {
                        if (!v) {
                            return 
                        }
                       const company = this.companies_hash[v]
                       this.params.company_name = company.name
                       // this.changeCb(company.com_city)
                    },
                    rules: [val => {
                       if (!val || val.length === 0) {
                        return '必选'
                       }
                        return true
                    }]
                 
                },
                {
                    label: '分类',
                    type: 'text_dis',
                    key: 'fl_employee_type',
                    cols: 3,
                    
                },
                // {
                //     label: '缴存地',
                //     type: 'text_dis',
                //     key: 'payment_place',
                //     cols: 3,
                {
                    label: '项目组',
                    type: 'team_tree_select',
                    key: 'team_id',
                    cols: 5,
                    change: (_, target) => {
                        this.params.team_name = target.full_name
                        if (target.level !== undefined && target.level === 0) {
                            this.$Modal.error({title: '错误',
                            content: "请至少选择1级部门"})
                        }
                    }
                },
                {
                    label: '发放批次',
                    type:'select_field_v1',
                    key: 'payment_batch',
                    cols: 3,
                    items: [
                        {
                            title: '正常发放',
                            key: 'normal',
                        },
                        {
                            title: '补发',
                            key: 'reissue',
                        },
                    ],
                    required: true,
                    rules: [bx]
                },
                {
                    label: '账户性质',
                    type:'select_field_v1',
                    key: 'account_nature',
                    required: true,
                    cols: 3,
                    items: [
                        {
                            title: '独立户',
                            key: 'segregated',
                        },
                        {
                            title: '非独立户',
                            key: 'non_segregated',
                        },
                    ],
                    rules: [bx]
                },
            ]
        },
        other_fields() {
            return [
                {
                    label: '入职调整',
                    type: 'number_field',
                    key: 'enter_quit_adjust_salary',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '上月补发工资',
                    type: 'number_field',
                    key: 'last_month_supply_salary',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '请假扣款',
                    type: 'number_field',
                    key: 'leave_deduct_salary',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '其他发放',
                    type: 'number_field',
                    key: 'other_subsidy',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '餐补',
                    type: 'number_field',
                    key: 'meal_subsidy',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '推荐奖',
                    type: 'number_field',
                    key: 'recommend_award',
                    required: true,
                    cols: 3,
                    rules: [bt]
                }
            ]
        },
        social_fund_fields() {
            return [
                {
                    label: '养老单位缴费金额',
                    type: 'number_field',
                    key: 'company_endowment_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '医疗单位缴费金额',
                    type: 'number_field',
                    key: 'company_medical_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '生育单位缴费金额',
                    type: 'number_field',
                    key: 'company_maternity_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '失业单位缴费金额',
                    type: 'number_field',
                    key: 'company_unemployment_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '工伤单位缴费金额',
                    type: 'number_field',
                    key: 'company_industrial_injury_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '补充医疗缴费金额',
                    type: 'number_field',
                    key: 'company_supplementary_medical_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: ' 公积金单位缴存额',
                    type: 'number_field',
                    key: 'company_accumulation_fund_amount',
                    required: true,
                    cols: 3,
                     
                },
                {
                    label: '养老个人缴费金额',
                    type: 'number_field',
                    key: 'person_endowment_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '医疗个人缴费金额',
                    type: 'number_field',
                    key: 'person_medical_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '失业个人缴费金额',
                    type: 'number_field',
                    key: 'person_unemployment_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '补充医疗个人缴费金额',
                    type: 'number_field',
                    key: 'person_supplementary_medical_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '公积金个人缴存额',
                    type: 'number_field',
                    key: 'person_accumulation_fund_amount',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
            ]
        },
        deduction_fields() {
            return [
                {
                    label: '子女教育',
                    type: 'number_field',
                    key: 'child_edu_deduct',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '住房贷款利息',
                    type: 'number_field',
                    key: 'housing_loan_deduct',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '住房租金',
                    type: 'number_field',
                    key: 'housing_rent_deduct',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '赡养老人',
                    type: 'number_field',
                    key: 'support_older_deduct',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '继续教育',
                    type: 'number_field',
                    key: 'continuing_edu_deduct',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '婴幼儿照护',
                    type: 'number_field',
                    key: 'baby_tend_deduct',
                    required: true,
                    cols: 3,
                    rules: [bt]
                }
            ]
        },
        personal_fields() {
            return [
                {
                    label: '个人养老金',
                    type: 'number_field',
                    key: 'personal_pension',
                    required: true,
                    cols: 3,
                    rules: [bt]
                }
            ]
        },
        individual_income_tax_fields() {
            return [
                {
                    label: '个税',
                    type: 'number_field',
                    key: 'individual_tax',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
            ]
        },
        severance_package_fields() {
            return [
                {
                    label: '离职补偿金',
                    type: 'number_field',
                    key: 'severance',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '竞业补偿金',
                    type: 'number_field',
                    key: 'non_competition',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '期权',
                    type: 'number_field',
                    key: 'option',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
                {
                    label: '离职补偿金个税',
                    type: 'number_field',
                    key: 'severance_tax',
                    required: true,
                    cols: 3,
                    rules: [bt]
                },
            ]
        },
        modify_fields() {
            return [
                {
                    label: '修改原因',
                    type: 'textareas_field',
                    rows: 3,
                    key: 'reason',
                    required: true,
                    cols: 12,
                    rules: [bt]
                },
                {
                    label: '工资条备注',
                    type: 'textareas_field',
                    rows: 3,
                    key: 'wage_memo',
                    cols: 12,
                },
                {
                    label: '其他发放说明',
                    type: 'textareas_field',
                    rows: 3,
                    key: 'other_subsidy_memo',
                    cols: 12,
                },
                // other_subsidy_memo
            ]
        }

    },
    mounted() {
      this.getSubsidizedMealsSetDetailHash()
      // this.show = false
    },
    methods: {
        changeCb(city) {
            if (!this.cb_cy_hash) {
                this.getSubsidizedMealsSetDetailHash(city)
                return
            }
            let city_clone = ''
            switch (city) {
                case '香港':
                        this.$Message.warning('无香港餐补数据！')
                        return;
                    case '成都':
                        city_clone = 'chengdu_value'
                    break
                    case '北京':
                        city_clone = 'beijing_value'
                    break;
                default:
                    break;
            }
          const should_working_day = getsafe(this.sourceData, 'should_working_day', 0)
          const enter_quit_adjust_day = getsafe(this.sourceData, 'enter_quit_adjust_day', 0)
          const last_month_working_day = getsafe(this.sourceData, 'last_month_working_day', 0)
          const v = this.cb_cy_hash[city_clone]
          const res = math.eval(`(${should_working_day || 0}+${enter_quit_adjust_day || 0}+${last_month_working_day || 0})*${v}/21.75`).toFixed(2)
          this.params.meal_subsidy = res
        },
        getSubsidizedMealsSetDetailHash(city) {
            getSubsidizedMealsSetDetailApi().then(res => {
                res.forEach(item => {
                   const employeeType = this.getEmployeeType(item) 
                    if (employeeType.includes('产研')) {
                        if (!this.cb_cy_hash) {
                            this.cb_cy_hash = {}
                        }
                        this.cb_cy_hash.beijing_value = item.beijing_value
                        this.cb_cy_hash.chengdu_value = item.chengdu_value
                        if (city) {
                           // this.changeCb(city)
                        }
                    }
                });
                // this.cb_cy_hash
            })
        },
        edit(data) {
            if (!this.cb_cy_hash) {
                this.getSubsidizedMealsSetDetailHash()
            }
            this.sourceData = data
            const params = createSalaryAdjustV2()
           const fl_employee_type = this.getEmployeeType(data)
            Object.keys(params).forEach(key => {
                switch (key) {
                    case 'customer_month_salary_detail_id':
                        params[key] = data.id
                        break;
                    case 'fl_employee_type': 
                        params[key] = fl_employee_type
                        break
                    case 'company_id': 
                        params[key] = Number(data[key])
                        break
                    default:
                        params[key] = data[key]
                        break;
                }
               
            })
            // 分析最底层部门
            if (data.level1_team_id) {
                params.team_id = data.level1_team_id
                params.team_name += `/${data.level1_team_name}`
            }
            if (data.level2_team_id) {
                params.team_id = data.level2_team_id
                params.team_name += `/${data.level2_team_name}`
            }
            this.params = params
            this.show = true
        },
        check() {
            let res = 0
            for (let i = 1;i <= 7;i++) {
                if (this.$refs[i] && !this.$refs[i].validate() && !res) {
                    res = i
                }
            }
            return res
        },
        submit() {
            const result = this.check()
            if (result) {
                this.$Message.warning('表单有误，请仔细检查！')
                this.scrollTo(result)
                return 
            }
            const {...params} = this.params
            const deleteObj = createSalaryAdjustV2Display()
            Object.keys(deleteObj).forEach(key => {
                delete params[key]
            })
            this.saveLoading = true
            adjustApi(params).then(() => {
                this.$Message.success({
                    content: '修改成功!'
                });
                this.$emit('success')
                this.show = false
            }).finally(() => {
                this.saveLoading = false
            })
        },
        scrollTo(index) {
            if (!this.forms_height) {
                const arr = []
                for (let i = 1;i <= 7;i++) {
                    arr.push(this.$refs[`c-${i}`].offsetHeight + (arr[arr.length - 1] || 0))
                }
                this.forms_height = arr
            }
            const c_height = this.forms_height[index - 2] || 0
            this.$refs.contain.scrollTo({top: c_height, behavior: 'smooth'})
        },
    },
    render() {
        const _this = this
        return <VModal 
        dynamicHeight
        heightRate={0.9}
        v-model={this.show}
        title='调整'
        loading={this.saveLoading}
        width={900}
        ref="modal"
        on={{
          ok: () => {
              _this.submit()
          }
        }}
    >
        <div style="height:100%;overflow:auto" ref="contain">

   
            <div class={styles['modal-contain']} >
                <div ref="c-1">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>个人信息</p>
                    <VForm 
                        ref="1"
                        v-model={this.params}
                        fields={this.base_fields}
                    />
                </div>
                <div ref="c-2">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>其他发放/扣除</p>
                    <VForm 
                        ref="2"
                        v-model={this.params}
                        fields={this.other_fields}
                    />
                </div>
                <div ref="c-3">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>社保/公积金</p>
                    <VForm 
                        ref="3"
                        v-model={this.params}
                        fields={this.social_fund_fields}
                    />
                </div>
                <div ref="c-4">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>专项附加扣除</p>
                    <VForm 
                        ref="4"
                        v-model={this.params}
                        fields={this.deduction_fields}
                    />
                </div>
                <div ref="c-5">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>个人养老金</p>
                    <VForm 
                        ref="5"
                        v-model={this.params}
                        fields={this.personal_fields}
                    />
                </div>
                <div ref="c-6">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>个税</p>
                    <VForm 
                        ref="6"
                        v-model={this.params}
                        fields={this.individual_income_tax_fields}
                    />
                </div>
                <div ref="c-7">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>离职补偿金</p>
                    <VForm 
                        ref="7"
                        v-model={this.params}
                        fields={this.severance_package_fields}
                    />
                </div>
                <div ref="c-8">
                    <p class={[s_styles['p-n'], s_styles['p-b']]}>其他</p>
                    <VForm 
                        ref="8"
                        v-model={this.params}
                        fields={this.modify_fields}
                    />
                </div>
            </div>
        </div>
    </VModal>
    }
}